import * as React from 'react';
import Svg, { Circle, Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} fill="none" {...props}>
        <Path
            fill={ds.colorValue.icon.primary}
            fillRule="evenodd"
            stroke={ds.colorValue.icon.primary}
            strokeWidth={1.75}
            d="M13.199 17.338c-1.334 1.334-2 2-2.829 2-.828 0-1.495-.666-2.828-2L5.093 14.89c-1.156-1.157-1.734-1.735-2.039-2.47-.304-.735-.304-1.552-.304-3.187V6.75c0-1.886 0-2.828.586-3.414.586-.586 1.528-.586 3.414-.586h2.483c1.635 0 2.452 0 3.187.304.735.305 1.313.883 2.47 2.04l2.448 2.448c1.334 1.333 2 2 2 2.828 0 .829-.666 1.495-2 2.829l-4.14 4.14Z"
            clipRule="evenodd"
        />
        <Circle cx={8.051} cy={7.92} r={1.5} fill="#222226" transform="rotate(-45 8.051 7.92)" />
    </Svg>
);
export { SvgComponent as PromoIconFull };
